import React from "react"
import Button from "~/components/ui/Button"

interface ComponentProps {
  totalRecords: number
  totalPages: number
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  perPage: number
}

const Pagination = ({
  totalRecords,
  totalPages,
  page,
  setPage,
  perPage,
}: ComponentProps) => {
  return (
    <nav
      className="flex items-center justify-between border-t border-gray-200 bg-white pt-4 pb-2 pl-2"
      aria-label="Pagination"
    >
      <div className="hidden xsm:block">
        <p className="text-sm text-gray-700">
          Showing <span className="font-medium">{perPage * page - perPage + 1}</span> to{" "}
          <span className="font-medium">{Math.min(perPage * page, totalRecords)}</span> of{" "}
          <span className="font-medium">{totalRecords}</span> results
        </p>
      </div>
      <div className="flex flex-1 justify-end">
        <Button variant="white" onClick={() => setPage(1)} disabled={page <= 1} className="ml-3">
          First
        </Button>
        <Button
          variant="white"
          onClick={() => {
            if (page > 1) setPage(page - 1)
          }}
          disabled={page <= 1}
          className="ml-3"
        >
          Previous
        </Button>
        <Button
          variant="white"
          onClick={() => {
            if (page < totalPages) setPage(page + 1)
          }}
          disabled={page >= totalPages}
          className="ml-3"
        >
          Next
        </Button>
        <Button variant="white" onClick={() => setPage(totalPages)} disabled={page >= totalPages} className="ml-3">
          Last
        </Button>
      </div>
    </nav>
  )
}

export default Pagination
